// reducers.js

const initialState = {
    percent: 0,
  }
  
  const profilePercentReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_PERCENT':
        return {
          ...state,
          percent: action.payload
        }
      default:
        return state
    }
  }
  
  export default profilePercentReducer
  